// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:"https://backend-olxs.onrender.com/" ,
});

export default axiosInstance;

export const weburl = "https://backend-olxs.onrender.com/";
// export const weburl = "https://backend-olxs.onrender.com/";

export const Homeurl = "https://helply.spacedeco.in/";
export const adminurl = "https://adminhelply.spacedeco.in/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://backend-olxs.onrender.com/';

// export const weburl = 'https://backend-2o7f.onrender.com/';
